import React from 'react';
import PropTypes from 'prop-types';
import './style.scss';

const BreadCrumb = ({ dataBreadcrumb, onClick }) => {
  const filteredBreadcrumb = dataBreadcrumb.filter(item => item.name);
  return (
    <div className="breadcrumb">
      <ul className="breadcrumb-list">
        {filteredBreadcrumb.map((item, index) =>
          index === filteredBreadcrumb.length - 1 ? (
            <li className="breadcrumb-item" key={index}>
              <h3 className="breadcrumb-title">{item.name}</h3>
            </li>
          ) : (
            <li className="breadcrumb-item" key={index}>
              {item.name ? (
                <a
                  className="breadcrumb-link"
                  href={item.path}
                  target="_parent"
                  onClick={e => {
                    onClick(e, item);
                  }}
                  rel="noreferrer"
                >
                  {item.name}
                </a>
              ) : (
                item.name
              )}
            </li>
          )
        )}
      </ul>
    </div>
  );
};

BreadCrumb.propTypes = {
  dataBreadcrumb: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      path: PropTypes.string,
      action: PropTypes.func
    })
  ).isRequired
};

export default BreadCrumb;
